module.exports = __webpack_public_path__ + "static/media/cam.59943d08.svg";